import { childrenReturnsIntakeReportBreadcrumbs } from '../../config';
import { LoaderBackdrop, NavigateLinks } from '@/components';
import { useReturnsIntakeReport } from '../../hooks';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import {
  SummaryHeader,
  SummaryList,
  SummaryBrief,
  CloseReturnsIntakesAction,
} from '../../components';

const ViewReturnsIntakeDetail = () => {
  const navigate = useNavigate();
  const {
    shippings,
    isLoading,
    activeTab,
    handleTabChange,
    driverName,
    driverId,
    status,
    stats,
    handleFinish,
    handleGoToStart,
  } = useReturnsIntakeReport();

  const breadcrumbs = useMemo(
    () => childrenReturnsIntakeReportBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <section className='flex flex-col w-full h-full gap-8 mb-12'>
      <NavigateLinks
        actualPage='Detalle de Rendición'
        breadcrumbs={breadcrumbs}
      />

      {isLoading && <LoaderBackdrop />}

      <section className='w-full flex flex-col gap-6'>
        <SummaryBrief
          driverName={driverName}
          driverId={driverId}
          status={status}
          title='Resumen de Rendición'
        />

        <div className='flex flex-col'>
          <SummaryHeader
            compliances={stats}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          <div className='bg-white rounded-b-xl rounded-tr-xl border border-gray-200 flex flex-col overflow-hidden'>
            <div className='p-6'>
              <SummaryList
                shippings={shippings}
                isLoading={isLoading}
                emptyMessage={
                  activeTab === 0
                    ? 'No hay pedidos devueltos'
                    : activeTab === 1
                      ? 'No hay pedidos inesperados'
                      : 'No hay pedidos no reportados'
                }
              />
            </div>
          </div>
        </div>

        {status === 'OPEN' && (
          <CloseReturnsIntakesAction
            onFinish={handleFinish}
            onGoToStart={handleGoToStart}
            isProcessing={isLoading}
            driverName={driverName}
          />
        )}
      </section>
    </section>
  );
};

export default ViewReturnsIntakeDetail;
